/**
 * Custom Variants Handler - Supports both old and new systems
 * Old system: Uses data attributes directly
 * New system: Uses JSON object for better performance
 */

// Load old variant data from JSON script tag
function loadOldVariantData() {
    const scriptTag = document.querySelector('script[id^="old-variant-data-"]');
    if (!scriptTag) return null;

    try {
        return JSON.parse(scriptTag.textContent);
    } catch (error) {
        console.error('Failed to parse old variant data:', error);
        return null;
    }
}

// Initialize OLD variant system (preloaded JSON data)
function initOldCustomVariants() {
    const variantData = loadOldVariantData();
    if (!variantData) {
        return;
    }

    // Select labels with data-variant-key attribute
    const labels = document.querySelectorAll('.variant-linkout-label[data-variant-key]');

    labels.forEach(label => {
        // Prevent adding multiple listeners
        if (label.dataset.initialized) return;
        label.dataset.initialized = 'true';

        label.addEventListener('click', function() {
            // Prevent duplicate clicks during processing
            if (this.classList.contains('processing')) return;
            this.classList.add('processing');

            const variantKey = this.dataset.variantKey;
            const variant = variantData[variantKey];

            if (!variant) {
                console.error('Old custom variants: No data for key', variantKey);
                this.classList.remove('processing');
                return;
            }

            // Form elements
            const productIdInput = document.querySelector('[name="product-id"]');
            const origPrice = document.querySelectorAll('.onetime-price');
            const subscriptionPriceEl = document.querySelector('.subscription-price');
            const sellingPlanInput = document.querySelector('[name="selling_plan"]');
            const variantIdInput = document.querySelector('.product-variant-id');

            // Update selection state
            document.querySelectorAll('.variant-linkout-label').forEach(el => el.classList.remove('is-Selected'));
            this.classList.add('is-Selected');

            // Update prices and form values
            if (origPrice) {
                origPrice.forEach(item => {
                    item.innerHTML = variant.price;
                });
            }

            if (subscriptionPriceEl) subscriptionPriceEl.innerHTML = variant.subscriptionPrice;
            if (productIdInput) productIdInput.value = variant.productId;
            if (sellingPlanInput && variant.subscriptionId) sellingPlanInput.value = variant.subscriptionId;
            if (variantIdInput) variantIdInput.value = variant.id;

            // Update product title
            if (variant.title) {
                updateProductTitleOld(variant.title);
            }

            // Update product image
            if (variant.featuredImage) {
                updateProductImageOld(variant.featuredImage);
            }

            // Update product badge
            updateProductBadgeOld(variant.badge);

            // Update accordions from preloaded data
            updateAccordionsFromData(variant);

            // Handle media gallery change
            if (variant.mediaId) {
                activateMedia(variant.mediaId);
            }

            // Trigger bulk form update if exists
            triggerOldBulkFormUpdateFromVariant(variant);

            // Sync .pdp-inline-price (skips on bulk pages where bulk-v2 owns it)
            captureVariantForInline(variant);
            updateInlinePrice(variant);

            // Remove processing flag
            requestAnimationFrame(() => {
                this.classList.remove('processing');
            });
        });
    });
}

// Update accordions from preloaded data (instant, no fetch)
function updateAccordionsFromData(variant) {
    const accordions = document.querySelectorAll('.accordion.border-t');

    if (accordions.length === 0) {
        return;
    }

    // Find and update Product Details accordion
    accordions.forEach((accordion, index) => {
        const titleEl = accordion.querySelector('summary span');
        const contentEl = accordion.querySelector('.accordion__content');

        if (!titleEl) {
            return;
        }

        const titleText = titleEl.textContent.trim();

        // Update Product Details / Potential Benefits accordion
        if (titleText === 'Product Details' || titleText === 'Potential Benefits') {
            if (variant.productDetailsTitle) {
                titleEl.textContent = variant.productDetailsTitle;
            }
            if (variant.productDetails && contentEl) {
                contentEl.innerHTML = variant.productDetails;
            }
        }

        // Update Key Ingredients accordion
        if (titleText === 'Key Ingredients') {
            if (variant.keyIngredients && contentEl) {
                contentEl.innerHTML = `<div class="custom-field--value">${variant.keyIngredients}</div>`;
            }
        }

        // Update How to Use accordion
        if (titleText === 'How to Use') {
            if (contentEl) {
                let howToUseHtml = '';

                if (variant.howToUseImage) {
                    howToUseHtml += `<a href="${variant.howToUseImage}&width=3000" data-fancybox>
                        <img alt="How to Use ${variant.title}" loading="lazy" class="zoom-padding mix-blend-multiply lg:px-24 aspect-[16/9] object-contain w-full h-auto" src="${variant.howToUseImage}&width=2000">
                    </a>`;
                }

                if (variant.howToUseText) {
                    howToUseHtml += `<div class="fc-field field__block-description field-type--text">
                        <div class="custom-field--value">${variant.howToUseText}</div>
                    </div>`;
                }

                if (howToUseHtml) {
                    contentEl.innerHTML = howToUseHtml;
                }
            }
        }

        // Update Label Info accordion
        if (titleText === 'Label Info') {
            if (variant.labelInfo && contentEl) {
                contentEl.innerHTML = `<a href="${variant.labelInfo}&width=3000" data-fancybox>
                    <img alt="${variant.title} Label" class="w-full mix-blend-multiply" src="${variant.labelInfo}&width=2000" loading="lazy">
                </a>`;
            }
        }
    });
}

// Trigger bulk form update from variant data (OLD system)
function triggerOldBulkFormUpdateFromVariant(variant) {
    const bulkContainer = document.querySelector('.bulk-purchase-v2');
    if (!bulkContainer) return;

    // For linked variants, we need to fetch the full product data
    // to get all selling plans, not just the single subscriptionId
    if (variant.handle) {
        fetchProductDataForBulk(variant.handle, {
            id: variant.id,
            productId: variant.productId,
            servingsPerBottle: variant.servingsPerBottle // Pass servings from linked variant data
        });
    } else {
        // Fallback: Parse price to cents and dispatch basic event
        let priceInCents = 0;
        if (variant.price) {
            const priceNum = parseFloat(variant.price.replace(/[^0-9.]/g, ''));
            priceInCents = isNaN(priceNum) ? 0 : Math.round(priceNum * 100);
        }

        const mockVariant = {
            id: variant.id,
            price: priceInCents,
            productId: variant.productId,
            servingsPerBottle: variant.servingsPerBottle
        };

        // Dispatch variant change event
        const variantChangeEvent = new CustomEvent('variant:change', {
            detail: mockVariant
        });
        document.dispatchEvent(variantChangeEvent);
    }
}

// Update product title (old system)
function updateProductTitleOld(title) {
    const titleSelectors = [
        '.product__title h1',
        '.product__title .h2',
        '.product__title h2',
        'h1.h2'
    ];

    for (const selector of titleSelectors) {
        const titleElement = document.querySelector(selector);
        if (titleElement) {
            titleElement.textContent = title;
            break;
        }
    }
}

// Update product image (old system)
function updateProductImageOld(imageUrl) {
    const imageSelectors = [
        '.product__media-item.is-active img',
        '.product__media-item:first-child img',
        '.product__media-list img:first-of-type',
        '#GalleryViewer img'
    ];

    for (const selector of imageSelectors) {
        const img = document.querySelector(selector);
        if (img) {
            img.src = imageUrl;
            if (img.srcset) {
                img.srcset = imageUrl;
            }
            break;
        }
    }
}

// Update product badge (old system)
function updateProductBadgeOld(badgeText) {
    const badgeWrapper = document.querySelector('.product-badge-wrapper');

    if (badgeText) {
        // Badge has content - show it
        if (badgeWrapper) {
            const badgeSpan = badgeWrapper.querySelector('.product-badge');
            if (badgeSpan) {
                badgeSpan.textContent = badgeText;
            }
            badgeWrapper.style.display = '';
        } else {
            // Create badge if it doesn't exist
            const productInfo = document.querySelector('.product__info-container');
            if (productInfo) {
                const newBadge = document.createElement('div');
                newBadge.className = 'product-badge-wrapper mb-4';
                newBadge.innerHTML = `<span class="product-badge !inline-flex items-center gap-2 text-white px-6 py-3 pt-3.5 bg-black rounded-full font-medium font-subheading text-xl hover:bg-[#333333] transition-colors no-underline w-auto">${badgeText}</span>`;
                productInfo.insertBefore(newBadge, productInfo.firstChild);
            }
        }
    } else {
        // No badge - hide it
        if (badgeWrapper) {
            badgeWrapper.style.display = 'none';
        }
    }
}


// Load variant data from JSON script tag (NEW system)
function loadVariantData() {
    const scriptTag = document.querySelector('script[id^="variant-data-"]');
    if (!scriptTag) return null;
    
    try {
        return JSON.parse(scriptTag.textContent);
    } catch (error) {
        console.error('Failed to parse variant data:', error);
        return null;
    }
}

// Initialize NEW variant system (JSON-based) - only for metafield variants
function initNewCustomVariants() {
    const variantData = loadVariantData();
    if (!variantData || !variantData.variants) {
        return;
    }

    const variants = variantData.variants;

    // Only select labels with the new data-variant-index attribute
    const labels = document.querySelectorAll('.variant-linkout-label[data-variant-index]:not(.disabled)');

    labels.forEach(label => {
        // Prevent adding multiple listeners
        if (label.dataset.initialized) return;
        label.dataset.initialized = 'true';

        label.addEventListener('click', function() {
            // Prevent duplicate clicks during processing
            if (this.classList.contains('processing')) return;
            this.classList.add('processing');

            const variantIndex = parseInt(this.dataset.variantIndex);
            const variant = variants[variantIndex];

            if (!variant) {
                console.error('Variant not found for index:', variantIndex);
                this.classList.remove('processing');
                return;
            }

            handleVariantChange.call(this, variant, variants);
        });
    });
}

// Handle variant change with optimized DOM updates
function handleVariantChange(selectedVariant, allVariants) {
    // Update selection state immediately for visual feedback
    document.querySelectorAll('.variant-linkout-label').forEach(el => el.classList.remove('is-Selected'));
    this.classList.add('is-Selected');

    // Update form inputs immediately
    updateFormInputs(selectedVariant);

    // Check if bulk form exists - coordinate price updates
    const bulkContainer = document.querySelector('.bulk-purchase-v2');

    // Handle price updates
    if (!bulkContainer) {
        // Only update prices directly if bulk form is not present
        updatePriceElements(selectedVariant);
    } else {
        // Trigger bulk form update for coordinated pricing
        triggerBulkFormUpdate(selectedVariant);
    }

    // Update product title
    updateProductTitle(selectedVariant);

    // Update product image
    updateProductImage(selectedVariant);

    // Handle media gallery change
    if (selectedVariant.mediaId) {
        activateMedia(selectedVariant.mediaId);
    }

    // Remove processing flag
    requestAnimationFrame(() => {
        this.classList.remove('processing');
    });
}

// Update form inputs with variant data
function updateFormInputs(variant) {
    const productIdInput = document.querySelector('[name="product-id"]');
    const sellingPlanInput = document.querySelector('[name="selling_plan"]');
    const variantIdInput = document.querySelector('.product-variant-id');

    if (productIdInput) productIdInput.value = variant.productId;
    if (sellingPlanInput) sellingPlanInput.value = variant.subscriptionId;
    if (variantIdInput) variantIdInput.value = variant.id;
}

// Update product title (only for metafield variants)
function updateProductTitle(variant) {
    if (!variant.productTitle) {
        return;
    }

    // Try multiple selectors for product title
    const titleSelectors = [
        '.product__title h1',
        '.product__title .h2',
        '.product__title h2',
        'h1.h2'
    ];

    for (const selector of titleSelectors) {
        const titleElement = document.querySelector(selector);
        if (titleElement) {
            titleElement.textContent = variant.productTitle;
            break;
        }
    }
}

// Update product image (only for metafield variants)
function updateProductImage(variant) {
    if (!variant.featuredImage) {
        return;
    }

    // Target the first/active product media item image
    const imageSelectors = [
        '.product__media-item.is-active img',
        '.product__media-item:first-child img',
        '.product__media-list img:first-of-type',
        '#GalleryViewer img'
    ];

    for (const selector of imageSelectors) {
        const img = document.querySelector(selector);
        if (img) {
            img.src = variant.featuredImage;
            if (img.srcset) {
                img.srcset = variant.featuredImage;
            }
            break;
        }
    }
}

// Update price elements directly (when bulk form is not present)
function updatePriceElements(variant) {
    const onetimePrices = document.querySelectorAll('.onetime-price');
    const subscriptionPrice = document.querySelector('.subscription-price');
    
    if (onetimePrices.length > 0) {
        onetimePrices.forEach(element => {
            element.innerHTML = variant.priceFormatted;
        });
    }
    
    if (subscriptionPrice) {
        subscriptionPrice.innerHTML = variant.subscriptionPriceFormatted;
    }

    captureVariantForInline(variant);
    updateInlinePrice(variant);
}

// ─────────────────────────────────────────────────────────────
// Inline price (.pdp-inline-price) sync for regular products.
// Bulk-v2 and bundle-variants own this element on their own pages,
// so this function is a no-op there. Handles size/linkout variant
// clicks and Recharge subscription radio toggles.
// ─────────────────────────────────────────────────────────────
let _lastVariantForInline = null;

function captureVariantForInline(variant) {
    if (variant) _lastVariantForInline = variant;
}

function updateInlinePrice(_variant, isSubscription) {
    // _variant is accepted for backward-compat but no longer used.
    // We read from the canonical .onetime-price / .subscription-price elements
    // which are kept up-to-date by all upstream systems (server render,
    // Recharge widget, updatePriceElements, OLD variant handler, bulk-v2).
    if (document.querySelector('.bulk-purchase-v2')) return;

    const inlineEls = document.querySelectorAll('.pdp-inline-price');
    if (!inlineEls.length) return;

    if (isSubscription === undefined) {
        const subRadio = document.querySelector('input[data-radio-type="selling_plan"]:checked');
        isSubscription = !!subRadio;
    }

    const sourceClass = isSubscription ? '.subscription-price' : '.onetime-price';
    const sourceEl = Array.from(document.querySelectorAll(sourceClass))
        .find(function (el) { return el && el.textContent.trim(); });

    const desired = sourceEl ? sourceEl.textContent.trim() : null;
    if (!desired) return; // no source price found — leave existing display untouched

    inlineEls.forEach(function (el) { el.textContent = desired; });
}

function setupInlinePriceRechargeSync() {
    try {
        const oldData = loadOldVariantData();
        if (oldData && oldData.current) _lastVariantForInline = oldData.current;
    } catch (e) {}

    // Catch direct `change` events on Recharge radios (fires when scripts dispatch them)
    document.addEventListener('change', function (e) {
        const t = e.target;
        if (!(t instanceof HTMLInputElement) || t.type !== 'radio') return;
        const isSub = t.dataset.radioType === 'selling_plan';
        const isOneTime = t.dataset.radioType === 'one_time_purchase';
        if (!isSub && !isOneTime) return;
        updateInlinePrice(_lastVariantForInline, isSub);
    });

    // Catch clicks on any purchase-type UI: .onetime / .subscription wrappers
    // (custom theme) OR anywhere inside the Recharge .selling_plan_theme_integration
    // container (handles WHT-style hidden-radio + label markup).
    document.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        const inPurchaseUI = e.target.closest('.onetime, .subscription, .selling_plan_theme_integration');
        if (!inPurchaseUI) return;
        // Defer one tick so radio .checked state has settled
        setTimeout(function () {
            const subRadio = document.querySelector('input[data-radio-type="selling_plan"]:checked');
            updateInlinePrice(_lastVariantForInline, !!subRadio);
        }, 0);
    });

    setTimeout(function () { updateInlinePrice(_lastVariantForInline); }, 800);
}

// Trigger bulk form updates for coordinated pricing (NEW system)
function triggerBulkFormUpdate(variant) {
    // Create mock variant object for bulk-v2 compatibility
    const mockVariant = {
        id: variant.id,
        price: variant.price,
        compare_at_price: null,
        productId: variant.productId, // Include productId for linked variant detection
        servingsPerBottle: variant.servingsPerBottle, // Include servings for per-serving price calculation
        selling_plan_allocations: []
    };

    // Add selling plan data if available
    if (variant.subscriptionId) {
        mockVariant.selling_plan_allocations = [{
            selling_plan_id: parseInt(variant.subscriptionId),
            price: variant.subscriptionPrice,
            selling_plan: {
                id: parseInt(variant.subscriptionId),
                name: 'Subscription'
            }
        }];
    }

    // Fetch full product data and dispatch variant change event
    // This will load ALL selling plans from the linked product
    fetchProductDataForBulk(variant.productHandle, mockVariant);
}

// Fetch product data for bulk form updates (no caching)
async function fetchProductDataForBulk(productHandle, baseVariant) {
    if (!productHandle) {
        console.error('fetchProductDataForBulk: No product handle provided');
        return;
    }

    try {
        const response = await fetch(`/products/${productHandle}.js`);

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const productData = await response.json();

        // Find the variant in the product data
        const fullVariant = productData.variants.find(v => v.id == baseVariant.id);
        if (!fullVariant) {
            console.error('Variant not found in product data:', baseVariant.id, 'for product:', productHandle);
            return;
        }

        // Add productId to help bulk-v2 detect linked variant switches
        fullVariant.productId = productData.id;

        // Preserve servingsPerBottle from the base variant if provided
        if (baseVariant.servingsPerBottle) {
            fullVariant.servingsPerBottle = baseVariant.servingsPerBottle;
        }

        // Add selling plan allocations from product data
        if (productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
            fullVariant.selling_plan_allocations = [];

            productData.selling_plan_groups.forEach(group => {
                if (group.selling_plans) {
                    group.selling_plans.forEach(plan => {
                        const allocation = {
                            selling_plan_id: plan.id,
                            selling_plan: plan,
                            price: fullVariant.price
                        };

                        // Apply discount from plan
                        if (plan.price_adjustments && plan.price_adjustments.length > 0) {
                            const adjustment = plan.price_adjustments[0];
                            if (adjustment.value_type === 'percentage' && adjustment.value) {
                                allocation.price = Math.round(fullVariant.price * (1 - adjustment.value / 100));
                            }
                        }

                        fullVariant.selling_plan_allocations.push(allocation);
                    });
                }
            });

        }

        // Dispatch custom event that bulk-v2 can listen for
        const variantChangeEvent = new CustomEvent('variant:change', {
            detail: fullVariant
        });
        document.dispatchEvent(variantChangeEvent);

    } catch (error) {
        console.error('Error fetching product data for bulk update:', error);
    }
}

// Optimized media gallery activation
function activateMedia(mediaId, attempts = 5) {
    const mediaGallery = document.querySelector('media-gallery');

    if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(mediaId, false);

        // Use requestAnimationFrame for smooth scrolling
        requestAnimationFrame(() => {
            const activeMedia = document.querySelector(`[data-media-id="${mediaId}"]`);
            const galleryList = activeMedia?.closest('.product__media-list');

            if (activeMedia && galleryList && window.innerWidth > 749) { // Desktop only
                const mediaRect = activeMedia.getBoundingClientRect();
                const galleryRect = galleryList.getBoundingClientRect();

                const isVisible = (
                    mediaRect.left >= galleryRect.left &&
                    mediaRect.right <= galleryRect.right
                );

                if (!isVisible) {
                    galleryList.scrollTo({
                        left: activeMedia.offsetLeft - 20,
                        behavior: 'smooth'
                    });
                }
            }
        });

    } else if (attempts > 0) {
        setTimeout(() => activateMedia(mediaId, attempts - 1), 100);
    } else {
        // media-gallery not ready
    }
}

// Handle purchase type selection (onetime/subscription)
function initPurchaseTypeHandlers() {
    ['.onetime', '.subscription'].forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
            el.addEventListener('click', function() {
                const input = this.querySelector('input');
                if (input) input.checked = true;
            });
        });
    });
}

// Initialize everything when DOM is ready
function initAll() {
    initOldCustomVariants();  // Initialize old system
    initNewCustomVariants();  // Initialize new system (metafield variants)
    initPurchaseTypeHandlers();
    setupInlinePriceRechargeSync();
}

// Run init once DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}